<mat-select [formControl]="dataController" placeholder="{{ label }}" panelClass="autocomplete-dropdown-panel" #singleSelect>
	<mat-option>
		<ngx-mat-select-search placeholderLabel="{{ 'Search' | tt }}"
		                       noEntriesFoundLabel="{{ 'No ' + label + ' found' | tt }}"
		                       [formControl]="dataFilteredController">
		</ngx-mat-select-search>
	</mat-option>

	<mat-option *ngFor="let option of filteredDataOptions | async" [value]="option">
		<span class="name">{{ option.name }}</span>
		<small class="sub_name" *ngIf="option.sub_name">
			<mat-icon aria-hidden="false"
			          aria-label="Example home icon"
			          *ngIf="showSubNameIcon(option)"
			          [fontIcon]="sub_name_icon"></mat-icon>
			{{ option.sub_name }}
		</small>
	</mat-option>
</mat-select>
